import React, { useState } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2"; // Import SweetAlert2
import { Save, FileText, Film, LogOut } from "react-feather";


const AddKeyValue = () => {
  const [key, setKey] = useState(""); // State for key
  const [value, setValue] = useState(""); // State for value
  const navigate = useNavigate(); // To navigate after successful submission
  const { listing_id } = useParams();
  console.log("Listing ID from URL:", listing_id);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent default form submission
    
    // Validation: Check if both fields are filled
    if (!key || !value) {
      // Show SweetAlert2 with an error message
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Please fill both the inputs!",
      });
      return; // Prevent the API call if validation fails
    }

    // Prepare data to send, including the listing_id
    const data = {
      key,
      value,
      listing_id, // Add listing_id here
    };

    // Log the data before sending
    console.log("Data to be sent:", data);

    try {
      // Make a POST request with data in the body
      const response = await axios.post(`${baseurl}seller/add-additional-details`, data, {
        headers: {
          "Content-Type": "application/json", // Ensure content type is JSON
        },
      });

      console.log("Response:", response.data);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Key-Value pair created successfully!",
      });
      
      // Reload the page after successful submission
      window.location.reload();
    } catch (error) {
      console.error("Error creating key-value:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error occurred while creating key-value pair.",
      });
    }
  };

  return (
    <>
      <div>
        <button type="button" className="btn submitbtnn me-2" data-bs-toggle="modal" data-bs-target="#exampleModal">
          Add Specification
        </button>

        <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">Add Specification</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <div className="modal-body">
                <div className="contact-form text-start">
                  <div className="row g-2">
                    <div className="col-md-3">
                      <label htmlFor="key" className="form-label">
                        Heading<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="key"
                        name="key"
                        className="form-control"
                        placeholder="Eg. Part Number"
                        value={key}
                        onChange={(e) => setKey(e.target.value)} // Set the key value
                        required
                      />
                    </div>

                    <div className="col-md-9">
                      <label htmlFor="value" className="form-label">
                        Value<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        id="value"
                        name="value"
                        className="form-control"
                        placeholder="Eg. 75552.00041-I, 249005/0804, 26659.00573, 196609/0904"
                        value={value}
                        onChange={(e) => setValue(e.target.value)} // Set the value
                        required
                      />
                    </div>

                    <div className="col-md-12 mt-3 text-end">
                      <button type="submit" className="btn submitbtnn w-25 me-2" onClick={handleSubmit}>
                        <Save size={17}/>&nbsp;Add Specification
                      </button>
                    </div>
                  </div>
                </div>
                 
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddKeyValue;
